import React from 'react';
import { ArrowRight, Star, Sparkles } from 'lucide-react';
import { BOOKING_URL } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-60 pointer-events-none" />
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#ea580c]/10 blur-[130px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[1.2fr_1fr] gap-14 items-center relative">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#0b0f0d]/15 bg-white text-[#0b0f0d] text-xs font-medium mb-6">
            <Sparkles size={13} className="text-[#ea580c]" /> Qualified leads for local contractors
          </div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-[68px] leading-[1.02] font-semibold text-[#0b0f0d]">
            Get <em className="italic text-[#ea580c] font-medium">30 to 50 qualified leads</em> every month for your local service business.
          </h1>
          <p className="mt-6 text-[#4a4f4c] text-lg max-w-xl leading-relaxed">
            Trusted Home Leads keeps painters, roofers, HVAC pros, plumbers, electricians and landscapers stocked with a steady flow of pre-qualified leads. We handle the front of the funnel so your team can focus on closing.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 bg-[#0b0f0d] hover:bg-[#1a1f1c] text-white font-semibold px-6 py-3.5 rounded-full">
              Book a Free Strategy Call <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#testimonials" className="inline-flex items-center gap-3 text-[#0b0f0d] hover:text-[#ea580c]">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} className="fill-[#ea580c] text-[#ea580c]" />
                ))}
              </div>
              <span className="text-sm font-medium">120+ contractors served</span>
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { k: '120+', v: 'Contractors served nationwide' },
              { k: '$12M+', v: 'Revenue generated for clients' },
              { k: '4.9★', v: 'Average client rating' },
            ].map((s) => (
              <div key={s.k} className="border-l border-[#0b0f0d]/10 pl-4">
                <div className="font-display text-2xl font-semibold text-[#0b0f0d]">{s.k}</div>
                <div className="text-xs text-[#6b6f6c] mt-1 leading-snug">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-4 bg-[#ea580c]/10 rounded-3xl blur-2xl" />
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-[#e8e4d8] shadow-2xl shadow-[#0b0f0d]/10">
            <img
              src="https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjb250cmFjdG9yJTIwd29ya2luZ3xlbnwwfHx8fDE3ODMwOTU0Mjh8MA&ixlib=rb-4.1.0&q=85"
              alt="Contractor at work"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b0f0d]/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 bg-white border border-[#e8e4d8] rounded-2xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-xs text-[#6b6f6c]">This week for Reilly Roofing</div>
                  <div className="font-display text-2xl font-semibold text-[#0b0f0d] mt-1">22 new leads</div>
                </div>
                <div className="text-[#ea580c] font-semibold text-sm">+267%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
